<template>
  <v-container
    id="grid"
    fluid
    grid-list-sm
    tag="section"
  >
   <v-layout row wrap>
      <v-flex xs3>
      <img src="https://www.unsw.adfa.edu.au/sites/default/files/logo_3.png" alt="UNSW Canberra" class="logo-image">
    </v-flex>
      <v-flex xs9 text-xs-left tag="h1" class="siteHeader">Database of the Australians who served in WW2</v-flex>
      <v-flex d-flex xs12 order-xs5>
        <v-layout column text-xs-left>
          <v-flex>
            <v-card flat>
              <v-card-text>{{ lorem }}</v-card-text>
            </v-card>
          </v-flex>

          <v-flex>
            <v-form >
              <v-layout row >
                <v-flex xs1></v-flex>
                <v-flex  xs5><v-text-field autofocus v-model='lastSearch.surname' label='Surname' v-on:keyup='searchIfEnter'/></v-flex>
                <v-flex ml-4 xs5><v-text-field v-model='lastSearch.firstNames' label='First names' v-on:keyup='searchIfEnter'/></v-flex>
                <v-flex xs1></v-flex>
              </v-layout>
              <v-layout row >
                <v-flex xs1></v-flex>
                <v-flex xs5><v-text-field v-model='lastSearch.serviceNum' label='Service number' v-on:keyup='searchIfEnter'/></v-flex>
                <v-flex ml-4 xs5><v-select v-model='lastSearch.service' :items="$serviceValues" label='Service'/></v-flex>
                <v-flex xs1></v-flex>
              </v-layout>
              <v-layout row >
                <v-flex xs12 class="text-xs-center">               
                  <v-btn @click="search">Search</v-btn>
                </v-flex>
              </v-layout>
            </v-form>
          </v-flex>

          <v-flex>
            <v-card flat>
              <v-card-text>{{ lorem }}</v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
    
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
      hdr: 'UNSW@Canberra',
      lastSearch: this.$globals.lastSearch,      
      lorem: `Sed ut perspiciatis unde omnis iste natus error sit voluptatem peter dennis accusantium doloremque 
           laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto
            beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur
             aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi
             nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, 
             adipisci velit, sed quia non numquam eius modi tempora incidunt kent fitch ut labore et dolore magnam 
             aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam 
             corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel
             eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, 
             vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?`
    }
  },
  async created () {
    await this.$getCodes() ;  // needed for everything - make sure we have them and they are up to date
  },

  methods: {
    searchIfEnter (e) {
      if (e.keyCode === 13) {
        console.log("home form ENTER") ;
        this.search() ;
      }
    },
    search () {
      console.log("************************ HOME SEARCH") ;
      var description = "" ;
      var query = {} ;
      if (this.lastSearch.surname) {
        description += "Surname starting with " + this.lastSearch.surname ;
        query.surname = this.lastSearch.surname ;
      }
      if (this.lastSearch.firstNames) {
        description += " First names starting with " + this.lastSearch.firstNames ;
        query.firstNames = this.lastSearch.firstNames ;
      }
      if (this.lastSearch.serviceNum) {
        description += " Service number: " + this.lastSearch.serviceNum ;
        query.serviceNum = this.lastSearch.serviceNum ;
      }
      if (this.lastSearch.service) {
        description += " In the " + this.lastSearch.service ;
        query.service = this.lastSearch.service ;
      }
      query.description = description ;
      query.showUnique = 'y' ;
      console.log("Off to search description=" + description + " query=" + JSON.stringify(query)) ;

      this.$router.push({ path: '/people', query: query }) ;
    }
  }
}
</script>

<style scoped>
.logo-image { max-width:200px }
.siteHeader { font-size:200%;margin-top:10px}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue